import request from '@/utils/request'

// 查询社区列表
export function listCommunity(query) {
  return request({
    url: '/parking/community/list',  // 通过网关访问
    method: 'get',
    params: query
  })
}

// Get a specific community
export function getCommunity(communityId) {
  return request({
    url: '/parking/community/' + communityId,
    method: 'get'
  })
}

// Get community option list 获取园区下拉列表
export function getCommunityOptionList(query) {
  return request({
    url: '/parking/community/communityOption',
    method: 'get',
    params: query
  })
}

// Get community information by parking space ID
export function getCommunityByParkingSpace(parkingSpaceId) {
  return request({
    url: '/parking/community/getByParkingSpace/' + parkingSpaceId,
    method: 'get'
  })
}

